<template>
  <div class="app-container">
    <form-table
      ref="baseForm"
      :queryOptions="searchFormData"
      :tableOptions="tableOptions"
      :headerTitle="headerTitle"
      :queryUrl="queryUrl"
      :btnData="btnData"
      @clickBtn="onSelect"
      :hasFormatFunctionParams="true"
      :formatFunctionParams="formatFunctionParams"
      :query-permission="['system:notice:query']"
    >
    </form-table>
  </div>
</template>

<script>
import { dataCenter } from '@/utils/dataCenter'
import { getDicts } from '@/api/dict/data'
export default {
  name: 'DAContract',
  dicts: ['sys_dealer_type'],
  data() {
    return {
      headerTitle: 'DA合同',
      btnData: [{ text: '下载' }],
      searchFormData: [
        { props: 'displayFileName', label: '文件名', type: 'input' },
        {
          props: 'dealerType',
          label: '经销商类型',
          type: 'input'
        },
        {
          props: 'dateFieldTwoStart',
          label: '生效日期',
          width: '120px',
          type: 'dateTime',
          valueFormat: 'yyyy-MM-dd',
          dateFormat: 'yyyy-MM-dd',
          dateType: 'date'
        },
        {
          props: 'dateFieldOneEnd',
          label: '失效日期',
          width: '120px',
          type: 'dateTime',
          valueFormat: 'yyyy-MM-dd',
          dateFormat: 'yyyy-MM-dd',
          dateType: 'date'
        }
      ],
      tableOptions: [
        {
          prop: 'displayFileName',
          label: '文件名',
          type: 'fileName',
          rightBottom: { prop: 'dealerType', label: '经销商类型' }
        },
        {
          prop: 'dateFieldOne',
          label: '生效日期',
          width: '120',
          sortable: true
        },
        {
          prop: 'dateFieldTwo',
          label: '失效日期',
          width: '120',
          sortable: true
        }
      ],
      funCode: 'DA_CONTRACT',
      queryUrl: '/bff-dp-mobile/meta-data-integration/data-list'
    }
  },
  created() {
    // this.setOptions()
  },
  methods: {
    formatFunctionParams(params) {
      return {
        ...params,
        funCode: this.funCode,
        reservedDateFormat: 'yyyy-MM-dd'
      }
    },
    async setOptions() {
      const options = await getDicts('sys_dealer_type').then(res => {
        let list = []
        if (res.code === 200 && res.data.length > 0) {
          list = res.data
        }
        return list
      })
      this.tableOptions[0].rightBottom.options = options
    },
    onSelect(text, queryParams, list) {
      console.log(text, queryParams)
      this.daowload(list)
    },
    daowload(list) {
      dataCenter.downloadFile(list)
    }
  }
}
</script>
